import { gql } from '@apollo/client';
import {
  CheckoutTotalAmountFields,
  core_apimessages_CheckoutLineItem_Type as CheckoutLineItemType,
  core_apimessages_MoneyMinorUnitsEntry,
} from '../schemas/rql';

type Checkout = CheckoutTotalAmountFields.Fragment;

function findAmountOwedLineItem(lineItems: CheckoutTotalAmountFields.LineItems[]) {
  return lineItems.find((lineItem) => lineItem.type === CheckoutLineItemType.AMOUNT_OWED);
}

export function findAmountOwed(checkout: Checkout): CheckoutTotalAmountFields.Amount {
  const { amount } = findAmountOwedLineItem(checkout.lineItems);

  return amount;
}

/** Used for submitting finalized amount checks */
export function findAmountOwedMinorUnits(checkout: Checkout): core_apimessages_MoneyMinorUnitsEntry {
  const { amountCents, currency } = findAmountOwed(checkout);

  return {
    amountCents,
    currency,
  };
}

export const CheckoutTotalAmountFragment = gql`
  fragment CheckoutTotalAmountFields on Checkout {
    _id
    lineItems {
      type
      amount {
        amountCents
        currency
        amount
      }
    }
  }
`;
